var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirmanualLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 550.9 119.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:hsl(205, 65%, 55%);}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.1,79.75h-25l-5.48,13H137.51l26.68-62h9.48l25.93,62h-13Zm-3.53-9.85-8.83-22.3-8.83,22.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.27,28.73a6.79,6.79,0,1,1-6.79,6.79h0A6.82,6.82,0,0,1,211.27,28.73Zm5.67,23.79V92.77h-11.3V52.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.36,52.52H237.7v6a13.52,13.52,0,0,1,5-5.57,12.37,12.37,0,0,1,6.69-1.77,14.28,14.28,0,0,1,4.83.93l-1.48,10.6a8.56,8.56,0,0,0-5.3-1.49,9.29,9.29,0,0,0-7.53,3.25c-2.14,2.7-2.23,6.14-2.23,8.92V92.77H226.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.18,30.77h8.74l16.45,39.41,17.19-39.41h8.71l10.41,62H321.44l-5.58-38.2-16.59,38.2h-4.09l-15.91-38.2L273,92.77H260.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.6,52.52h11.34V92.77H370.6V87.56a14.43,14.43,0,0,1-12.33,6.51c-12.36,0-20.54-9.67-20.54-21.47s8.09-21.38,20-21.38c3.06,0,9.1.56,12.91,6.51ZM349.41,72.6C349.41,79,354.06,84,360.57,84s11.15-5,11.15-11.43a11.16,11.16,0,1,0-22.31-.66Q349.4,72.27,349.41,72.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391.33,52.52h11.34v5.21a14.75,14.75,0,0,1,12.45-6.51c3.53,0,8.74,1,11.9,4.93,2.79,3.44,3.16,7.43,3.16,11.34V92.77H418.84V70.83c0-2.23-.09-5.76-2.14-7.9a7.26,7.26,0,0,0-5.3-2,7.74,7.74,0,0,0-7,3.53c-1.67,2.6-1.76,5.48-1.76,7.81v20.5H391.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M450.9,52.52v22.8c0,2.14.19,5,2.42,7.07a9.15,9.15,0,0,0,11.52,0c2.23-2.07,2.43-5,2.43-7.07V52.52h11.34V77.15c0,3.63-.47,8.46-4.93,12.36-3.71,3.26-9.66,4.56-14.59,4.56s-10.87-1.3-14.59-4.56c-4.46-3.9-4.93-8.73-4.93-12.36V52.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M518.84,52.52h11.34V92.77H518.84V87.56a14.41,14.41,0,0,1-12.36,6.51c-12.36,0-20.54-9.67-20.54-21.47s8.09-21.38,20-21.38c3.07,0,9.11.56,12.92,6.51ZM497.65,72.6C497.65,79,502.3,84,508.8,84S520,79,520,72.6a11.16,11.16,0,1,0-22.31-.66Q497.64,72.27,497.65,72.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M550.9,25V92.77H539.57V25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.54,25.81c-1.73,1.16-8.2,7.46-21.38,41-2.78,7.08-5.36,14.12-7.54,20.27H88.47c-2.18-6.15-4.76-13.19-7.54-20.27C67.75,33.27,61.28,27,59.54,25.81ZM74,81.31l-.6-1.13a68.46,68.46,0,0,0-6.1-9.66,54.38,54.38,0,0,0-3.84,5.21c-1,1.45-1.91,3-2.8,4.48l-1.11,1.88-1.1-1.88c-.89-1.52-1.83-3-2.8-4.48a54.38,54.38,0,0,0-3.84-5.21,68.46,68.46,0,0,0-6.1,9.66l-.6,1.13-6.47-3.44.61-1.13c7.65-14.38,10.92-14.38,12.5-14.38s3.81.76,7.8,6.12c4-5.36,6.19-6.12,7.81-6.12s4.85,0,12.5,14.38l.61,1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.4,0H10.69A10.68,10.68,0,0,0,0,10.67V108.4a10.7,10.7,0,0,0,10.69,10.69H108.4a10.71,10.71,0,0,0,10.69-10.69V10.69A10.7,10.7,0,0,0,108.4,0Zm-3.65,103.71H94.16c-.53-1.61-1.25-3.78-2.14-6.4H27.07c-.89,2.62-1.61,4.79-2.14,6.4H14.34l-.17,0c.07-.22,6.89-21.6,15.29-42.7C45.37,21,53.32,15.41,59.52,15.38h0c6.2,0,14.15,5.61,30.06,45.58,8.4,21.1,15.22,42.48,15.29,42.7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirmanualLogo);
export default __webpack_public_path__ + "static/media/airmanual-logo.fac83812143635372ddaecb45a49b80b.svg";
export { ForwardRef as ReactComponent };